import React, { useEffect } from 'react';
import LandingNavbar from '../components/Landing/LandingNavbar';
import LandingFooter from '../components/Landing/LandingFooter';
import './landing.css';
import techStackImg from '../assets/tech_stack.png';

const TechStackPage: React.FC = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.tech-category, .tech-item').forEach(el => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="main-landing-admin">
            <LandingNavbar />

            <section className="hero-sub">
                <div className="container hero-sub-container">
                    <div className="hero-sub-content">
                        <h1 className="section-title gradient-text" style={{ textAlign: 'left', marginBottom: '1.5rem' }}>Our <span>Technology Stack</span></h1>
                        <p className="hero-description" style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1.25rem', lineHeight: '1.6' }}>
                            We use the most advanced and reliable technologies to power our AI intelligence platform.
                        </p>
                        <div style={{ marginTop: '2rem' }}>
                            <div className="tech-badge" style={{ display: 'inline-block', marginRight: '1rem', marginBottom: '1rem' }}>Modern Architecture</div>
                            <div className="tech-badge" style={{ display: 'inline-block', marginRight: '1rem', marginBottom: '1rem' }}>Enterprise Ready</div>
                        </div>
                    </div>

                    <div className="featured-image-container">
                        <img src={techStackImg} alt="Technology Stack" className="featured-image" />
                    </div>
                </div>
            </section>

            <section style={{ padding: '6rem 0' }}>
                <div className="container">
                    <h2 className="section-title">Technical <span>Excellence</span></h2>
                    <div className="tech-categories">
                        <div className="tech-category">
                            <h3>Artificial Intelligence & ML</h3>
                            <p className="category-desc">Our core intelligence is built using industry-leading frameworks for deep learning and neural networks.</p>
                            <div className="tech-items">
                                <div className="tech-badge">TensorFlow</div>
                                <div className="tech-badge">PyTorch</div>
                                <div className="tech-badge">Scikit-learn</div>
                                <div className="tech-badge">Keras</div>
                                <div className="tech-badge">Hugging Face</div>
                                <div className="tech-badge">OpenAI GPT</div>
                            </div>
                        </div>

                        <div className="tech-category">
                            <h3>Data Engineering</h3>
                            <p className="category-desc">Scalable pipelines to process, clean, and prepare your data for high-accuracy AI training.</p>
                            <div className="tech-items">
                                <div className="tech-badge">Apache Spark</div>
                                <div className="tech-badge">Pandas</div>
                                <div className="tech-badge">NumPy</div>
                                <div className="tech-badge">Dask</div>
                                <div className="tech-badge">Airflow</div>
                                <div className="tech-badge">Kafka</div>
                            </div>
                        </div>

                        <div className="tech-category">
                            <h3>Cloud & Infrastructure</h3>
                            <p className="category-desc">Robust enterprise-grade cloud architecture ensuring 99.9% uptime and global scalability.</p>
                            <div className="tech-items">
                                <div className="tech-badge">AWS</div>
                                <div className="tech-badge">Azure</div>
                                <div className="tech-badge">GCP</div>
                                <div className="tech-badge">Docker</div>
                                <div className="tech-badge">Kubernetes</div>
                                <div className="tech-badge">Terraform</div>
                            </div>
                        </div>

                        <div className="tech-category">
                            <h3>Modern Web Stack</h3>
                            <p className="category-desc">Clean, responsive, and fast user interfaces built with modern web standards.</p>
                            <div className="tech-items">
                                <div className="tech-badge">React</div>
                                <div className="tech-badge">TypeScript</div>
                                <div className="tech-badge">Next.js</div>
                                <div className="tech-badge">Node.js</div>
                                <div className="tech-badge">FastAPI</div>
                                <div className="tech-badge">PostgreSQL</div>
                                <div className="tech-badge">MongoDB</div>
                                <div className="tech-badge">Redis</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <LandingFooter />
        </div>
    );
};

export default TechStackPage;
